import { Box, Checkbox, Card, Snackbar, Backdrop, Button, FormControl, Select, CardContent, CardHeader, Container, Grid, Dialog, TextField, Typography, Stepper, Step, StepLabel } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';
import Autocomplete from '@mui/material/Autocomplete';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import SendIcon from '@mui/icons-material/Send';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import UploadFile from '../../components/UploadFileForApplication';
import Photo from '../../components/Photo';
import Alert from 'src/components/Alert';
import SectionBlock from 'src/components/SectionBlock';

const DefaultConsumerChangeValue = {
  ApplicationId: 0,
  OpenType: 0,
  ServiceType: '',
  CityLocation: '',
  ServiceLocation: '',
  Country: '',
  Town: '',
  PersonType: '',
  ServiceInfo: '',
  Devir: 0,
  Birlesme: 0,
  Subelesme: 0,
  Findeks: ''
};

const styles = {
  root: (theme) => ({
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  }),
  rootlist: {
    width: '100%',
    bgcolor: 'background.paper',
    position: 'relative',
    overflow: 'auto',
    maxHeight: 550,
  },
  rootlistsag: {
    width: '100%',
    bgcolor: 'background.paper',
    position: 'relative',
    overflow: 'auto',
    maxHeight: 500,
  },

  cardBolum: {
    maxHeight: 700,
    minHeight: 700,
    width: '100%'
  },
  table: {
    minWidth: 650,
  },
  content: {
    minHeight: 550,
  },
  chatSection: {
    width: '100%',
  },
  avatar: {
    cursor: 'pointer',
    width: 40,
    height: 40
  },
  headBG: {
    backgroundColor: '#e0e0e0'
  },
  borderRight500: {
    borderRight: '1px solid #e0e0e0'
  },
  messageArea: {
    overflowY: 'auto'
  },
  button: (theme) => ({
    margin: theme.spacing(1),
  }),
  backdrop: (theme) => ({
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  }),
  actionsCCFile: {
    justifyContent: 'flex-end'
  }
};
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

function Chat() {
  const params = useParams();
  const [Loading, setLoading] = useState(false);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = React.useState('default');
  const [uyariAciklama, setUyariAciklama] = useState('');
  const SessionUser = getUser();
  const [comment, setComment] = useState("")
  const [servisAcilisTip, setServisAcilisTip] = useState([]);
  const [servisKisi, setServisKisi] = useState([]);
  const [servisKonum, setServisKonum] = useState([]);
  const [servisLokasyonIl, setServisLokasyonIl] = useState([]);
  const [servisLokasyonIlce, setServisLokasyonIlce] = useState([]);
  const [servisLokasyonKonum, setServisLokasyonKonum] = useState([]);
  const [servisTip, setServisTip] = useState([]);
  const [birimler, setbirimler] = useState([]);
  const [birlesenBirimler, setBirlesenBirimler] = useState([]);
  const [openTypeValue, setOpenTypeValue] = useState(0);
  const [personType, setPersonType] = useState(0);
  const [location, setlocation] = useState(0);
  const [locationCity, setLocationCity] = useState(0);
  const [locationType, setLocationType] = useState(0);
  const [serviceType, setServiceType] = useState(0);
  const [adaySayisi, setAdaySayisi] = useState(1);
  const [adaySayisiDosyaAdet, setadaySayisiDosyaAdet] = useState([]);
  const [locationIlce, setLocationIlce] = useState(0);
  const [devirOlanBirim, setDevirOlanBirim] = useState(0);
  const [sirketlesenBirim, setSirketlesmeBirim] = useState(0);
  const [subelesenBirim, setSubelesenBirim] = useState(0);
  const [ortaklasanBirim, setOrtaklasanBirim] = useState([]);
  const [fileList, setFileList] = React.useState([])
  const [maxId, setMaxId] = useState(0);
  const [photoPopUp, setPhotoPopUp] = useState(false);
  const [formData, setFormdata] = useState(DefaultConsumerChangeValue);
  const [dosyaTipi, setDosyaTipi] = useState(1);
  const [fileTypeData, setFileTypeData] = React.useState([])
  const [disabled, setDisabled] = useState(false);
  const [uploadingFile, setUploadingFile] = useState([]);
  const [filesDataToSend, setFilesDataToSend] = useState([]);
  const [constFileTypeData, setConstFileTypeData] = useState([]);
  const [activeStep, setActiveStep] = useState(0);
  const stepLabels = ['Açılış Bilgileri', 'Konum Bilgileri', 'Kişi ve Birim Bilgileri', 'Ek Bilgi ve Dosyalar'];

  const handleOpenType = (itemValue, cityValue) => {
    const data = {
      ItemValue: itemValue,
      ItemId: 1,
      CityValue: cityValue
    }
    const config = {
      headers: { 'Content-Type': 'application/json' }
    }
    axios.post('GetCatalogItems', data, config).then((response) => {
      if (response.data.length > 0) {
        const res = response.data[0]
        setLoading(false);
        setServisAcilisTip(res.AcilisTipi)
        setServisKisi(res.ServisKisi)
        setServisKonum(res.ServisKonum)
        setServisLokasyonIl(res.ServisLokasyonIl)
        setServisLokasyonIlce(res.ServisLokasyonIlce)
        setServisLokasyonKonum(res.ServisLokasyonKonum)
        setServisTip(res.ServisTipi)
        setbirimler(res.BolgeyeBagliBirim)
        setMaxId(res.MaxId[0].Id)
      } else {
        setLoading(false);
      }
    }).catch(error => {
      setLoading(false);
    });
  }


  function handleDocumentType(itemValue) {
    if (itemValue.Id == 5) {
      setDosyaTipi(2);
      handleFileType(2);
    } else {
      setDosyaTipi(1);
      handleFileType(1);
    }
  }


  useEffect(() => {
    handleOpenType()
    let mounted = true;
    return () => {
      mounted = false;
    };
  }, [SessionUser.TopServiceShopCode, SessionUser.TechnicianId]);

  function servisKisiSayisi(value) {
    setAdaySayisi(value);
    var adet = value;
    var arr = [];
    for (var i = 0; i < adet; i++) {
      arr.push(i)
    }
    setadaySayisiDosyaAdet(arr);
  }

  const showStepWarning = (message) => {
    setUyariAciklama(message);
    setUyariTip('error');
    setUyari(true);
    return false;
  };

  const validateStep = (step) => {
    if (step === 0) {
      if (openTypeValue.Id == undefined || serviceType.Dsc == undefined) {
        return showStepWarning('Lütfen ilgili alanları kontrol ediniz!!.');
      }
      return true;
    }
    if (step === 1) {
      if (serviceType.Id !== 2) {
        if (locationType.ACIKLAMA == undefined || location.Dsc == undefined
          || locationCity.Dsc == undefined || locationIlce.ACIKLAMA == undefined) {
          return showStepWarning('Lütfen ilgili alanları kontrol ediniz!!.');
        }
      } else if (locationCity.Dsc == undefined || locationIlce.ACIKLAMA == undefined) {
        return showStepWarning('Lütfen ilgili alanları kontrol ediniz!!.');
      }
      return true;
    }
    if (step === 2) {
      if (personType.ID == undefined) {
        return showStepWarning('Lütfen ilgili alanları kontrol ediniz!!.');
      }
      if (personType.ID === 2 && adaySayisi == 0) {
        return showStepWarning('Lütfen kişi sayisi seçiniz!!.');
      }
      if (openTypeValue.Id === 5 && subelesenBirim.Id == undefined) {
        return showStepWarning('Lütfen şube açan  birimi seçiniz!...');
      }
      if (openTypeValue.Id === 2 && devirOlanBirim.Id == undefined) {
        return showStepWarning('Lütfen devir olan birimi seçiniz!...');
      }
      if (openTypeValue.Id === 3 && sirketlesenBirim.Id == undefined) {
        return showStepWarning('Lütfen şirketleşme işlemi gerçekleşen birimi seçiniz!...');
      }
      if (openTypeValue.Id === 4 && birlesenBirimler.length == 0) {
        return showStepWarning('Lütfen birleşme işlemi gerçekleşen birimi seçiniz!...');
      }
      return true;
    }
    return true;
  };

  const handleNextStep = () => {
    if (validateStep(activeStep)) {
      setActiveStep((prev) => prev + 1);
    }
  };

  const handleBackStep = () => {
    setActiveStep((prev) => prev - 1);
  };

  const handleApply = (event) => {
    //Ticari servis değilse
    if ((serviceType.Id !== 2) && (openTypeValue.Id == undefined || serviceType.Dsc == undefined || locationType.ACIKLAMA == undefined || location.Dsc == undefined
      || locationCity.Dsc == undefined || locationIlce.ACIKLAMA == undefined || personType.ID == undefined)) {
      setUyariAciklama('Lütfen ilgili alanları kontrol ediniz!!.')
      setUyariTip('error')
      setUyari(true)
      return;
    }
    //Ticari servis ise
    if (serviceType.Id === 2 && (openTypeValue.Id == undefined || serviceType.Dsc == undefined 
      || locationCity.Dsc == undefined || locationIlce.ACIKLAMA == undefined || personType.ID == undefined)) {
      setUyariAciklama('Lütfen ilgili alanları kontrol ediniz!!.')
      setUyariTip('error')
      setUyari(true)
      return;
    }
    if (personType.ID == 2 && adaySayisi == 0) {
      setUyariAciklama('Lütfen kişi sayisi seçiniz!!.')
      setUyariTip('error')
      setUyari(true)
      return;
    }
    if (openTypeValue.Id === 5 && subelesenBirim.Id == undefined) {
      setUyariAciklama('Lütfen şube açan  birimi seçiniz!...')
      setUyariTip('error')
      setUyari(true)
      return;
    }
    if (openTypeValue.Id === 2 && devirOlanBirim.Id == undefined) {
      setUyariAciklama('Lütfen devir olan birimi seçiniz!...')
      setUyariTip('error')
      setUyari(true)
      return;
    }
    if (openTypeValue.Id === 3 && sirketlesenBirim.Id == undefined) {
      setUyariAciklama('Lütfen şirketleşme işlemi gerçekleşen birimi seçiniz!...')
      setUyariTip('error')
      setUyari(true)
      return;
    }
    if (openTypeValue.Id === 4 && birlesenBirimler.length == 0) {
      setUyariAciklama('Lütfen birleşme işlemi gerçekleşen birimi seçiniz!...')
      setUyariTip('error')
      setUyari(true)
      return;
    }
    let differentTypeIds = [];
    fileTypeData.reduce((acc, item) => {
      if (!uploadingFile.some(element => element.TypeId === item.ID) && (item.ZORUNLU === 1)) {
        differentTypeIds.push({
          ID: item.ID, ACIKLAMA: item.ACIKLAMA
        });
      } return acc;
    }, []);
    if (differentTypeIds.length > 0) {
      setUyariAciklama(`Lütfen ${differentTypeIds[0].ACIKLAMA} dosyasını yükleyiniz!...`)
      setUyariTip('error')
      setUyari(true)
      return;
    }
    setLoading(true);
    const formData = new FormData();
    formData.append('ApplicationId', maxId + 1);
    formData.append('OpenType', openTypeValue.Id);
    formData.append('ServiceType', serviceType.Dsc);
    formData.append('CityLocation', locationType.ACIKLAMA);
    formData.append('ServiceLocation', location.Dsc);
    formData.append('Country', locationCity.Dsc);
    formData.append('Town', locationIlce.ACIKLAMA);
    formData.append('PersonType', personType.ID);
    formData.append('ServiceInfo', comment);
    formData.append('Devir', devirOlanBirim.Id || null);
    //formData.append('Birlesme', birlesenBirimler);
    for (var i = 0; i < birlesenBirimler.length; i++) {
      formData.append('BirlesmeId', birlesenBirimler[i].Id);
      formData.append('BirlesmeDsc', birlesenBirimler[i].Dsc);
    }
    formData.append('Sirketlesme', sirketlesenBirim.Id || null);
    formData.append('Subelesme', subelesenBirim.Id || null);
    //formData.append('Ortaklasma', ortaklasanBirim);
    for (var i = 0; i < ortaklasanBirim.length; i++) {
      formData.append('OrtaklasmaId', ortaklasanBirim[i].Id);
      formData.append('OrtaklasmaDsc', ortaklasanBirim[i].Dsc);
    }
    formData.append('PersonNumber', adaySayisi);
    formData.append('UserId', "");
    formData.append('ReceiptNumber', 0);
    formData.append('AdaySayisiId', adaySayisi);
    formData.append('CreateUser', "");
    formData.append('OnOnay', 1);
    formData.append('OpenClose', 1);
    uploadingFile.forEach((file) => {
      formData.append('File', file.FileUploadData.file);
      formData.append('FileName', file.FileName);
      formData.append('FileType', file.FileType);
      formData.append('TypeId', file.TypeId);
    });

    axios.post('/UploadFileNew', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(response => {
      let ResponseData = response.data;
      if (ResponseData.errorCode == 0) {
        setUyariAciklama(ResponseData.errorDescription);
        setUyari(true);
        setUyariTip("success")
        setOpenTypeValue(0);
        setComment('');
        setBirlesenBirimler([]);
        setServiceType(0);
        ClearData();
        setActiveStep(0);
        setLoading(false);

      } else {
        setUyariTip("error");
        setUyariAciklama(ResponseData.errorDescription);
        setUyari(true);
        setLoading(false);
      }
    }).catch(error => {
      setUyariAciklama("Bir hata oluştu!..")
      setUyariTip("error");
      setUyari(true);
      setLoading(false);
    });




    // uploadingFile.map((item) => {
    //   const dataMessage = {
    //     ApplicationId: maxId + 1,
    //     OpenType: openTypeValue.Id,
    //     ServiceType: serviceType.Dsc,
    //     CityLocation: locationType.ACIKLAMA,
    //     ServiceLocation: location.Dsc,
    //     Country: locationCity.Dsc,
    //     Town: locationIlce.ACIKLAMA,
    //     PersonType: personType.ID,
    //     ServiceInfo: comment,
    //     Devir: devirOlanBirim.Id,
    //     Birlesme: birlesenBirimler,
    //     Sirketlesme: sirketlesenBirim.Id,
    //     Subelesme: subelesenBirim.Id,
    //     Ortaklasma: ortaklasanBirim,
    //     PersonNumber: adaySayisi,
    //     UserId: "", //okta
    //     ReceiptNumber: 0,
    //     AdaySayisiId: adaySayisi,
    //     FileName: item.FileName,
    //     FileType: item.FileType,
    //     FileData: item.FileData,
    //     TypeId: item.TypeId,
    //     CreateUser: "",
    //     OnOnay: 1,
    //     OpenClose: 1,
    //     File: item.FileUploadData,
    //   };
    // })
    // const configMessage = {
    //   headers: { 'Content-Type': 'application/json' }
    // }
    // axios.post('/SetApplication', dataMessage, configMessage).then(response => {
    //   let ResponseDataMessage = response.data[0];
    //   if (ResponseDataMessage.ErrorCode == 0) {
    //     setUyariAciklama(ResponseDataMessage.ErrorDescription);
    //     setUyari(true);
    //     setUyariTip("success")
    //     setOpenTypeValue(0);
    //     setComment('');
    //     setBirlesenBirimler([]);
    //     setServiceType(0);
    //     setLoading(false);
    //     ClearData();

    //   } else {
    //     setUyariTip("error");
    //     setUyariAciklama(ResponseDataMessage.ErrorDescription);
    //     setUyari(true);
    //     setLoading(false);
    //   }
    // }).catch(error => {
    //   setUyariAciklama("Bir hata oluştu!..")
    //   setUyariTip("error");
    //   setUyari(true);
    //   setLoading(false);
    // });
  }

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const handleFileType = (documentType) => {
    axios.get(`/GetFileType/` + documentType)
      .then((response) => {
        const res = response.data;
        setConstFileTypeData(res);
        if (serviceType.Id === 2) {
          setFileTypeData(res.filter((item) => item.ACIKLAMA !== "Çagrilarin Merkezilesmesi Protokolü"));
        } else {
          setFileTypeData(res);
        }
      }).catch(error => {
      });
  }

  function ClearData() {
    setOpenTypeValue(0);
    setServiceType(0);
    setLocationType(0);
    setLocationCity(0);
    setLocationType(0);
    setlocation(0);
    setLocationCity(0);
    setLocationIlce(0);
    setServiceType(0);
    setComment("");
    setDevirOlanBirim(0);
    setBirlesenBirimler([]);
    setOrtaklasanBirim([]);
    setSirketlesmeBirim(0);
    servisKisiSayisi(1);
    setUploadingFile([]);
    setFileTypeData([]);
  }

  const controlHandleFileTypeData = (value) => {
    if (openTypeValue.Id === 5 && value.Id === 2) {
      //fileTypedatan acıklaması "Çagrilarin Merkezilesmesi Protokolü" olan dosya tipini çıkar
      setFileTypeData(constFileTypeData.filter((item) => item.ACIKLAMA !== "Çagrilarin Merkezilesmesi Protokolü"));
    }
    else {
      setFileTypeData(constFileTypeData);
    }
  }

  return (
    <Page sx={styles.root}>
      <Backdrop sx={styles.backdrop} open={Loading}>
        <CircularProgress color="inherit" />
        <Typography position='absolute'
          style={{ color: '#FF9800', marginLeft: '10px', fontWeight: 'bold', fontSize: '20px' }}>
          Dosya boyutuna göre biraz zaman alabilir. Lütfen bekleyiniz...</Typography>
      </Backdrop>
      <Snackbar open={uyari} autoHideDuration={10000} onClose={uyariKapat}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert onClose={uyariKapat} variant={uyariTip} message={uyariAciklama}>
        </Alert>
      </Snackbar>
      <Container maxWidth="xl">
        <Card>
          <CardHeader title="Servis Açılış Talebi" subheader={'Id: ' + (maxId + 1)} />
          <Divider />
          <CardContent>
            <Stepper activeStep={activeStep} sx={{ mb: 3 }}>
              {stepLabels.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>

            {activeStep === 0 && (
            <SectionBlock title="Açılış Bilgileri">
              <Grid
                size={{
                  xs: 12,
                  sm: 3,
                  lg: 2
                }}>
                <Autocomplete
                  size="small"
                  fullWidth
                  disableClearable
                  value={openTypeValue}
                  options={servisAcilisTip}
                  getOptionLabel={(option) => (option.Dsc ? option.Dsc : '')}
                  isOptionEqualToValue={(option, value) => option.Id === value.Id}
                  renderInput={(params) => <TextField {...params} label={('Açılış Tipi')} variant="outlined" required />}
                  onChange={(event, value) => {
                    setOpenTypeValue(value);
                    if (value.Id === 3 || value.Id === 4) {
                      setPersonType({ ID: 2, ACIKLAMA: 'Tüzel Kişi' });
                      setDisabled(true);
                    } else {
                      setPersonType(0);
                      setDisabled(false);
                    }
                    handleOpenType(SessionUser.TopServiceShopCode, locationCity);
                    handleDocumentType(value);
                  }}
                />
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  sm: 3,
                  lg: 2
                }}>
                <Autocomplete
                  size="small"
                  fullWidth
                  disableClearable
                  value={serviceType}
                  options={servisTip || []}
                  getOptionLabel={(option) => (option.Dsc ? option.Dsc : '')}
                  isOptionEqualToValue={(option, value) => option.Id === value.Id}
                  renderInput={(params) => <TextField {...params} label={('Servis Tipi')} variant="outlined" required />}
                  onChange={(event, value) => {
                    setServiceType(value);
                    controlHandleFileTypeData(value);
                  }}
                />
              </Grid>
            </SectionBlock>
            )}

            {activeStep === 1 && (
            <SectionBlock title="Konum Bilgileri">
              {serviceType.Id != 2 ?
                <Grid
                  size={{
                    xs: 12,
                    sm: 3,
                    lg: 2
                  }}>
                  <Autocomplete
                    size="small"
                    fullWidth
                    disableClearable
                    value={locationType}
                    options={servisLokasyonKonum || []}
                    getOptionLabel={(option) => (option.ACIKLAMA ? option.ACIKLAMA : '')}
                    isOptionEqualToValue={(option, value) => option.Id === value.Id}
                    renderInput={(params) => <TextField {...params} label={('İl Konumu')} variant="outlined" required
                      inputProps={{
                        ...params.inputProps,
                        autoComplete: 'new-password', // disable autocomplete and autofill
                      }}
                    />}
                    onChange={(event, value) => setLocationType(value)}
                  />
                </Grid>
                : null}
              {serviceType.Id != 2 ?
                <Grid
                  size={{
                    xs: 12,
                    sm: 3,
                    lg: 2
                  }}>
                  <Autocomplete
                    size="small"
                    fullWidth
                    disableClearable
                    value={location}
                    options={servisKonum}
                    getOptionLabel={(option) => (option.Dsc ? option.Dsc : '')}
                    isOptionEqualToValue={(option, value) => option.Id === value.Id}
                    renderInput={(params) => <TextField {...params} label={('Servis Konumu')} variant="outlined" required />}
                    onChange={(event, value) => setlocation(value)}
                  />
                </Grid>
                : null}
              <Grid
                size={{
                  xs: 12,
                  sm: 3,
                  lg: 2
                }}>
                <Autocomplete
                  size="small"
                  fullWidth
                  disableClearable
                  value={locationCity}
                  options={servisLokasyonIl}
                  autoComplete="off"
                  getOptionLabel={(option) => (option.Dsc ? option.Dsc : '')}
                  isOptionEqualToValue={(option, value) => option.Id === value.Id}
                  renderInput={(params) => <TextField {...params} label={('Lokasyon İl')} variant="outlined" required
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: 'new-password', // disable autocomplete and autofill
                    }}
                  />}
                  onChange={(event, value) => {
                    setLocationIlce(0);
                    setLocationCity(value);
                    handleOpenType(SessionUser.TopServiceShopCode, value?.Id);
                  }}
                />
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  sm: 3,
                  lg: 2
                }}>
                <Autocomplete
                  size="small"
                  fullWidth
                  disableClearable
                  value={locationIlce}
                  options={servisLokasyonIlce}
                  autoComplete="off"
                  getOptionLabel={(option) => (option.ACIKLAMA ? option.ACIKLAMA : '')}
                  isOptionEqualToValue={(option, value) => option.ID === value.ID}
                  renderInput={(params) => <TextField {...params} label={('Lokasyon İlçe')} variant="outlined" required
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: 'new-password', // disable autocomplete and autofill
                    }}
                  />}
                  onChange={(event, value) => setLocationIlce(value)}
                />
              </Grid>
            </SectionBlock>
            )}

            {activeStep === 2 && (
            <SectionBlock title="Kişi ve Birim Bilgileri">
              <Grid
                size={{
                  xs: 12,
                  sm: 3,
                  lg: 2
                }}>
                <Autocomplete
                  size="small"
                  fullWidth
                  disableClearable
                  value={personType}
                  options={servisKisi || []}
                  getOptionLabel={(option) => (option.ACIKLAMA ? option.ACIKLAMA : '')}
                  isOptionEqualToValue={(option, value) => option.ID === value.ID}
                  renderInput={(params) => <TextField {...params} label={('Servis Kişi')} variant="outlined" required />}
                  onChange={(event, value) => setPersonType(value)}
                  disabled={disabled} />
              </Grid>
              {personType.ID === 2 ?
                <Grid
                  size={{
                    xs: 12,
                    sm: 3,
                    lg: 2
                  }}>
                  <FormControl
                    fullWidth
                    size="small"
                    variant="outlined"
                  >
                    <Select
                      fullWidth
                      native
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      value={adaySayisi}
                      onChange={(event) => { servisKisiSayisi(event.target.value) }}
                    >
                      <option value={0}>0</option>
                      <option value={1}>1</option>
                      <option value={2}>2</option>
                      <option value={3}>3</option>
                      <option value={4}>4</option>
                      <option value={5}>5</option>
                      <option value={6}>6</option>
                      <option value={7}>7</option>
                      <option value={8}>8</option>
                      <option value={9}>9</option>
                      <option value={10}>10</option>
                    </Select>
                  </FormControl>
                </Grid>
                : null}
              {openTypeValue.Id === 2 ?
                <Grid
                  size={{
                    xs: 12,
                    sm: 3,
                    lg: 2
                  }}>
                  <Autocomplete
                    size="small"
                    fullWidth
                    disableClearable
                    value={devirOlanBirim}
                    options={birimler}
                    getOptionLabel={(option) => (option.Dsc ? option.Dsc : '')}
                    isOptionEqualToValue={(option, value) => option.Id === value.Id}
                    renderInput={(params) => <TextField {...params} label={('Devir Olan Servis')} variant="outlined" />}
                    onChange={(event, value) => { setDevirOlanBirim(value); }}
                  />
                </Grid>
                : null}
              {openTypeValue.Id === 3 ?
                <Grid
                  size={{
                    xs: 12,
                    sm: 3,
                    lg: 2
                  }}>
                  <Autocomplete
                    size="small"
                    fullWidth
                    disableClearable
                    value={sirketlesenBirim}
                    options={birimler}
                    getOptionLabel={(option) => (option.Dsc ? option.Dsc : '')}
                    isOptionEqualToValue={(option, value) => option.Id === value.Id}
                    renderInput={(params) => <TextField {...params} label={('Şirketleşen Servis')} variant="outlined" />}
                    onChange={(event, value) => { setSirketlesmeBirim(value); }}
                  />
                </Grid>
                : null}
              {openTypeValue.Id === 4 ?
                <Grid
                  size={{
                    xs: 12,
                    sm: 3,
                    lg: 2
                  }}>
                  <Autocomplete
                    multiple
                    size="small"
                    id="multiple-limit-tags"
                    fullWidth
                    limitTags={1}
                    disableCloseOnSelect
                    value={birlesenBirimler}
                    options={birimler}
                    getOptionLabel={(option) => (option.Dsc ? option.Dsc : '')}
                    onChange={(event, newValue) => { setBirlesenBirimler(newValue); }}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.Dsc}
                      </li>
                    )
                    }
                    renderInput={(params) => (
                      <TextField {...params} label="Birleşen Servisler" variant="outlined" />
                    )}
                  />
                </Grid>
                : null}
              {openTypeValue.Id === 5 ?
                <Grid
                  size={{
                    xs: 12,
                    sm: 3,
                    lg: 2
                  }}>
                  <Autocomplete
                    size="small"
                    fullWidth
                    disableClearable
                    value={subelesenBirim}
                    options={birimler}
                    getOptionLabel={(option) => (option.Dsc ? option.Dsc : '')}
                    isOptionEqualToValue={(option, value) => option.Id === value.Id}
                    renderInput={(params) => <TextField {...params} label={('Şube Açan Servis')} variant="outlined" />}
                    onChange={(event, value) => { setSubelesenBirim(value); }}
                  />
                </Grid>
                : null}
              {openTypeValue.Id === 1 && serviceType.Id === 3 ?
                <Grid
                  size={{
                    xs: 12,
                    sm: 3,
                    lg: 2
                  }}>
                  <Autocomplete
                    multiple
                    size="small"
                    fullWidth
                    limitTags={1}
                    disableCloseOnSelect
                    value={ortaklasanBirim}
                    options={birimler}
                    getOptionLabel={(option) => (option.Dsc ? option.Dsc : '')}
                    onChange={(event, value) => { setOrtaklasanBirim(value); }}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.Dsc}
                      </li>
                    )
                    }
                    renderInput={(params) => <TextField {...params} label={('Ortaklaşan Servisler')} variant="outlined" />}

                  />
                </Grid>
                : null}
            </SectionBlock>
            )}

            {activeStep === 3 && (
            <>
            <SectionBlock title="Ek Bilgi">
              <Grid
                size={{
                  xs: 12,
                  sm: 6,
                  lg: 4
                }}>
                <TextField
                  size="small"
                  id="comment"
                  value={comment}
                  onChange={event =>
                    setComment(event.target.value)}
                  fullWidth
                  multiline
                  minRows={2}
                  label={'Servis Hakkında Bilgi'}
                  helperText="Servis adayı olan kişi veya ortaklar ile ilgili genel bilgilendirme yazılmalı (Eski Arçelik Servis teknisyeni, iş tecrübesi vb.)"
                  variant="outlined"
                  autoComplete='off'
                />
              </Grid>
            </SectionBlock>

            <Box sx={{ backgroundColor: '#f7f8fa', borderRadius: 2, p: 2, mb: 2 }}>
              <Typography
                variant="overline"
                sx={{ display: 'block', color: 'text.secondary', fontWeight: 700, letterSpacing: 0.75, lineHeight: 1.2, mb: 1 }}
              >
                Dosyalar
              </Typography>
              <UploadFile basvuruId={maxId + 1} documentType={fileTypeData} dosyaAdet={adaySayisi} documentTypeNumber={1}
                openClose={1} uploadingFile={uploadingFile} setUploadingFile={setUploadingFile} setFilesDataToSend={setFilesDataToSend} />
            </Box>
            </>
            )}

            <Box sx={{ mt: 1, display: 'flex', gap: 1.5 }}>
              <Button
                variant="outlined"
                color="secondary"
                startIcon={<ArrowBackIcon />}
                disabled={activeStep === 0}
                onClick={handleBackStep}
              >
                Geri
              </Button>
              {activeStep < stepLabels.length - 1 ? (
                <Button
                  variant="contained"
                  color="secondary"
                  fullWidth
                  endIcon={<ArrowForwardIcon />}
                  onClick={handleNextStep}
                >
                  İleri
                </Button>
              ) : (
                <Button
                  variant="contained"
                  color="secondary"
                  fullWidth
                  endIcon={<SendIcon />}
                  onClick={() => {
                    handleApply()
                  }}
                >
                  ONAYA GÖNDER
                </Button>
              )}
            </Box>
          </CardContent>
          <Dialog
            open={photoPopUp}
            fullWidth={true}
            maxWidth={'xl'}
            onClose={() => setPhotoPopUp(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <Grid container >
              <Grid
                size={{
                  xs: 12,
                  sm: 12,
                  lg: 12
                }}>
                <Photo> </Photo>
              </Grid>
            </Grid>
          </Dialog>
        </Card>
      </Container>
    </Page >
  );
}

export default Chat;
